export function isFirefoxMobile(): boolean {
  return /Android.*Firefox|Mobile.*Firefox/i.test(navigator.userAgent);
}
